import { StyledSpinner } from './ButtonSpinner.styles';

const ButtonSpinner = () => {
  return <StyledSpinner src="/svg/loading_uranium_blue.svg" alt="Spinner icon" />;
};

export default ButtonSpinner;
